"use client";

import { PaymentPlan, ProductData, QuoteData } from "@capex/types";
import { ArrowLongLeftIcon } from "@heroicons/react/24/outline";
import React from "react";
import { GenericButton } from "../general/button.component";
import { PageFrameComponent } from "../general/page-frame.component";

export const BenefitsComponent = ({
  setStage,
  productData,
  quote,
  paymentPlans,
  currentStage,
}: {
  setStage: (stage: number) => void;
  productData: ProductData;
  quote: QuoteData;
  paymentPlans: PaymentPlan[];
  currentStage: number;
}) => {
  const premium =
    quote.productCode !== "CSP"
      ? quote.premium
      : quote.premium + quote.lifeCoverPremium;

  return (
    <PageFrameComponent>
      <div className="h-full grid grid-cols-1 place-content-center w-full">
        <div className="text-center mb-9">
          <p className="text-secondary font-medium text-2xl md:text-3xl">
            Your{" "}
            <span className="font-bold capitalize">{productData.Name}</span>{" "}
            benefit is:
          </p>
        </div>
        <div className="w-full md:w-[550px] mx-auto">
          <div className="bg-white w-full mb-12 rounded-2xl shadow-xl shadow-[rgba(0, 0, 0, 0.08)] border border-[#eee]">
            <div className="flex flex-col items-center p-4 gap-1">
              <p className="font-medium text-lg text-accent mt-3 mb-6">
                Quote Number:
                <span className="text-text-dark ml-3">{quote.quoteNo}</span>
              </p>
              <p className="font-bold text-2xl md:text-3xl text-text-dark">
                ₦ {quote.sumAssured.toLocaleString()}
              </p>
              <p className="font-normal text-lg md:text-xl text-text-mid">
                ₦ {premium.toLocaleString()}{" "}
                {`(${
                  paymentPlans.find(
                    (item) => item.planCode === quote.paymentTerm
                  )?.plan
                })`}
              </p>
            </div>
            <div className="mx-5">
              <p className="mb-2">Breakdown</p>
              <div className="bg-[#f6f6f6] w-full mb-3 rounded-xl px-5 py-3.5">
                <div className="flex flex-wrap items-center justify-between text-sm text-accent mt-2">
                  <span>
                    After {quote.policyTerm}{" "}
                    {Number(quote.policyTerm) > 1 ? "years" : "year"}
                  </span>
                  <span className="text-text-dark">
                    ₦ {Number(quote.sumAssured.toFixed(2)).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>

            <div
              className="bg-secondary w-full rounded-b-2xl flex justify-center py-2 md:py-3 cursor-pointer"
              onClick={() => setStage(4)}
            >
              <p className="font-medium text-white text-lg md:text-xl">
                Buy Now
              </p>
            </div>
          </div>

          <div
            className={`flex w-full ${
              currentStage === 3 ? "justify-center" : "justify-between"
            }`}
          >
            {currentStage !== 3 && (
              <GenericButton
                className="bg-accent flex justify-center items-center gap-x-3 !w-[155px] md:!w-[230px] lg:!w-[245px]"
                onClick={() => setStage(2)}
              >
                <ArrowLongLeftIcon className="w-6 h-6" />
                Back
              </GenericButton>
            )}

            <GenericButton className="bg-primary !w-[155px] md:!w-[230px] lg:!w-[245px]">
              Download Quote
            </GenericButton>
          </div>
        </div>
      </div>
    </PageFrameComponent>
  );
};
